export const FreeShippingBadge = () => {
  return (
    <p
      data-testid="pickup-option-price"
      className="text-restructure-primary text-font-size-1 leading-[18px] font-semibold py-[2px] px-1 bg-mint"
    >
      Grátis
    </p>
  )
}

export const ExpressShippingBadge = () => {
  return (
    <p className="text-white text-font-size-1 leading-[18px] font-semibold py-[2px] px-1 bg-restructure-background-neutral-12 whitespace-nowrap">
      Retire após 2h
    </p>
  )
}
